import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(3),
  '& .PSTitle': {
    padding: theme.spacing(3, 0),
    textTransform: 'uppercase',
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(32),
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  '& .PSTitleHint': {
    color: theme.palette.primary.main,
  },
  '& .PSPlanCard': {
    width: theme.spacing(75),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.secondary.main,
    paddingBottom: theme.spacing(3),
    textAlign: 'center',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      maxWidth: theme.spacing(75),
    },
  },
  '& .PSPlanItem': {
    padding: theme.spacing(3, 0),
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    width: theme.spacing(45.75),
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  '& .PSPlanTitle': {
    fontSize: theme.typography.pxToRem(28),
    lineHeight: theme.typography.pxToRem(40),
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),
  },
  '& .PSPricePerMonth': {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(26),
    padding: theme.spacing(2, 0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  '& .PSPrice': {
    fontSize: theme.typography.pxToRem(60),
    lineHeight: theme.typography.pxToRem(48),
  },
  '& .PSPriceStar': {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(18),
    verticalAlign: 'top',
  },
  '& .PSBtn': {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(24),
  },
  '& .PSBenfites': {
    padding: theme.spacing(2),
  },
  '& .PSBenfiteItem': {
    marginBottom: theme.spacing(1.5),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  '& .PSNote': {
    maxWidth: theme.spacing(75),
    color: theme.palette.grey[200],
    textAlign: 'center',
  },
  '& .PSCompareBtn': {
    padding: 0,
    margin: theme.spacing(3, 0),
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      width: theme.typography.pxToRem(300),
    },
  },
  '& .PSCompareBtnText': {
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(32),
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  '& .PSCompareBtnIcon': {
    width: theme.typography.pxToRem(32),
    height: theme.typography.pxToRem(32),
    marginLeft: theme.spacing(1.25),
    position: 'relative',
    top: theme.typography.pxToRem(4),
    [theme.breakpoints.down('lg')]: {
      width: theme.typography.pxToRem(28),
      height: theme.typography.pxToRem(28),
    },
    [theme.breakpoints.down('md')]: {
      width: theme.typography.pxToRem(26),
      height: theme.typography.pxToRem(26),
    },
  },
}));

export default StyledBox;
